import {clientMessage} from '@/intake/clientMessages'

const guardCodes = ['INITIAL_SESSION_ALREADY_SCHEDULED', 'CONFIRMED_LIMIT_EXCEEDED']

/** Use only the current server denial; cached drafts never choose a resume target. */
export function bookingGuardRecovery(error, lang = 'fa') {
  const body = error && error.response && error.response.data
  const data = (body && body.data) || (error && error.data) || error || {}
  const reasons = Array.isArray(data.reason_codes) ? data.reason_codes
    : (error && Array.isArray(error.reason_codes) ? error.reason_codes : [])
  const code = [error && error.code, data.code, data.reason_code, ...reasons, error && error.message]
    .find(value => guardCodes.includes(value))
  if (!code) return null
  const rawId = data.user_session_id || data.resume_user_session_id
  const id = rawId == null ? '' : String(rawId)
  const ownedSession = code === 'INITIAL_SESSION_ALREADY_SCHEDULED' && /^[1-9]\d{0,19}$/.test(id)
  return {
    code,
    message: clientMessage(code, lang),
    label: lang === 'fa' ? (ownedSession ? 'مشاهدهٔ جلسهٔ رزروشده' : 'مشاهدهٔ جلسات')
      : (ownedSession ? 'View scheduled session' : 'View sessions'),
    route: {
      name: ownedSession ? 'portalSessionDetail' : 'portalSessions',
      params: {lang},
      ...(ownedSession ? {query: {id}} : {}),
    },
  }
}
